import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["loading", "disabled", "invalid", "inline", "rightAdornment", "size", "width", "minWidth", "maxWidth", "dateInputRef", "maskInputRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { IconFunctionalCalendar16 } from '@cian/ui-kit-design-tokens/icons';
import { InputAdornment } from '../../../../inputAdornment';
import { InputWrapper } from '../../../../internal/components/InputWrapper';
import { InputWrapperInput } from '../../../../internal/components/InputWrapperInput/InputWrapperInput';
import { FocusObserver } from '../../../../internal/components/FocusObserver/FocusObserver';
import { useDeviceType } from '../../../../responsive/hooks/useDeviceType/useDeviceType';
import { NativeDateMaskInput } from '../NativeDateMaskInput';
import { NativeDateInput } from '../NativeDateInput';
import * as styles from './styles.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DateInputInput = /*#__PURE__*/React.forwardRef(function DateInputInput(props, ref) {
  var loading = props.loading,
    disabled = props.disabled,
    invalid = props.invalid,
    inline = props.inline,
    rightAdornment = props.rightAdornment,
    size = props.size,
    width = props.width,
    minWidth = props.minWidth,
    maxWidth = props.maxWidth,
    dateInputRef = props.dateInputRef,
    maskInputRef = props.maskInputRef,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focused = _React$useState2[0],
    setFocused = _React$useState2[1];
  var deviceType = useDeviceType();
  var isMobile = deviceType === 'phone';
  return /*#__PURE__*/_jsxs(InputWrapper, {
    ref: ref,
    focused: focused,
    loading: loading,
    disabled: disabled,
    inline: inline,
    invalid: invalid,
    leftAdornment: /*#__PURE__*/_jsx(InputAdornment, {
      children: /*#__PURE__*/_jsx(IconFunctionalCalendar16, {
        color: "icon-main-default"
      })
    }),
    rightAdornment: rightAdornment,
    size: size,
    width: width,
    minWidth: minWidth,
    maxWidth: maxWidth,
    className: clsx(styles['wrapper'], isMobile && styles['mobile']),
    children: [/*#__PURE__*/_jsx(FocusObserver, {
      onChange: setFocused,
      children: /*#__PURE__*/_jsx(NativeDateMaskInput, _objectSpread(_objectSpread({}, rest), {}, {
        ref: maskInputRef,
        as: InputWrapperInput,
        className: styles['input-mask'],
        disabled: props.disabled,
        name: undefined
      }))
    }), /*#__PURE__*/_jsx(NativeDateInput, _objectSpread(_objectSpread({}, rest), {}, {
      ref: dateInputRef,
      className: styles['input-date']
    }))]
  });
});